import { render } from "./HomeCRM.vue?vue&type=template&id=78d21520&scoped=true"
import script from "./HomeCRM.vue?vue&type=script&lang=js"
export * from "./HomeCRM.vue?vue&type=script&lang=js"

import "./HomeCRM.vue?vue&type=style&index=0&id=78d21520&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d21520"]])

export default __exports__